function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-folder-open"
}, "Folder Open Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.22,31.7H38.73l-2.71-3H28.88a3.21,3.21,0,0,0-3.2,3.19V48.12a3.21,3.21,0,0,0,3.2,3.19H51.22a3.21,3.21,0,0,0,3.19-3.19V34.89A3.21,3.21,0,0,0,51.22,31.7Z"
});

var SvgIconFolderOpen = function SvgIconFolderOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-folder-open",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-folder-open"
  }, title) : null, _ref3, React.createElement("path", {
    d: "M57.66,48.19a4.14,4.14,0,0,1-3.86,3.12H28.38c-.06,0-.1-.05-.09-.09l2.77-13a4.13,4.13,0,0,1,3.86-3.12H57.26a2.48,2.48,0,0,1,2.52,3.12Z",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFolderOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-folder-open.2686eb25.svg";
export { ForwardRef as ReactComponent };